import { useSyncExternalStore, type ReactNode } from "react";
import { AdaptiveTextScope } from "../../components/ui";
import { isQuestionGroupContainerRaw } from "../questionGroup/core";
import { questionRegistry } from "../registry";
import { ActiveQuestion } from "./ActiveQuestion";
import { ActiveQuestionGroup } from "./ActiveQuestionGroup";
import type { SessionQuestionSlotProps } from "./types";

export type { AttemptDraftState, SessionQuestionSlotProps } from "./types";

export const SessionQuestionSlot = (props: SessionQuestionSlotProps) => {
  const snapshot = useSyncExternalStore(
    props.session.subscribe,
    props.session.getSnapshot,
  );
  const attempt = snapshot.attempt;
  if (!attempt) return null;
  let content: ReactNode;
  if (isQuestionGroupContainerRaw(attempt.question.question)) {
    content = <ActiveQuestionGroup {...props} attempt={attempt} />;
  } else {
    const module = questionRegistry.get(attempt.question.question.type);
    if (!module)
      throw new Error(
        `Unsupported survey question type: ${attempt.question.question.type}`,
      );
    content = <ActiveQuestion {...props} attempt={attempt} module={module} />;
  }
  return <AdaptiveTextScope>{content}</AdaptiveTextScope>;
};
